import { Marker, OverlayView } from "@react-google-maps/api";

export default function DriverLabelMarker({ marker, mapPin }) {
  const position = {
    lat: Number(marker.current_latitude),
    lng: Number(marker.current_longitude)
  };

  return (
    <>
      {/* Actual Marker Pin */}
      <Marker
        position={position}
        icon={{
          url: mapPin,
          scaledSize: new window.google.maps.Size(24, 24)
        }}
      />

      {/* Custom Label */}
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_LAYER}
      >
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "-42px",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
            fontSize: "12px",
            fontWeight: "600",
            whiteSpace: "nowrap",
            zIndex: 9999,
          }}
        >
          <span style={{ fontWeight: 400, marginRight: "4px" }}>{marker.driver_id} : </span>{marker.driver_name}
        </div>
      </OverlayView>
    </>
  );
}
